import React from 'react';
import { useParams } from 'react-router-dom';
import { useAccountId } from '../../redux/slices/appInfo/hooks';
import { TypedMemo } from '../common/types';
import { LoadingView } from '../common/views/LoadingView';
import { FullScreenUpgradeHost } from '../music24/components/SMLUpgradeModal/FullScreenUpgradeHost';
import { DirectedVideoOpener } from './shell/DirectedVideoOpener';
import { DirectedVideoScreen } from './shell/DirectedVideoScreen';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the directed video; each part uses its own slice of it */
import styles from './DirectedVideo.module.scss';
/* eslint-enable css-modules/no-unused-class */

/**
 * The directed video route (design directed-video b1):
 * `/app/catalog/song/:catalogItemUuid/directed-video[/:directedVideoUuid][?step=&from=]`. It fills the
 * screen like the music video editor: no app sidebar, only the wizard with its own top bar. With no
 * video uuid it opens or makes the video of the song (`DirectedVideoOpener`). The key starts a new
 * wizard for each artist, song and video.
 */
const DirectedVideoViewComponent: React.FC = () => {
  const accountId = useAccountId();
  const { catalogItemUuid, directedVideoUuid } = useParams<{ catalogItemUuid: string; directedVideoUuid?: string }>();
  let body: React.ReactNode;
  if (accountId === null || catalogItemUuid === undefined) {
    body = <LoadingView />;
  } else if (directedVideoUuid === undefined || directedVideoUuid === '') {
    body = (
      <DirectedVideoOpener
        key={`${accountId}:${catalogItemUuid}`}
        accountId={accountId}
        catalogItemUuid={catalogItemUuid}
      />
    );
  } else {
    body = (
      <DirectedVideoScreen
        key={`${accountId}:${catalogItemUuid}:${directedVideoUuid}`}
        accountId={accountId}
        catalogItemUuid={catalogItemUuid}
        directedVideoUuid={directedVideoUuid}
      />
    );
  }
  return (
    <div className={styles.screen} data-fullscreen-editor>
      {body}
      {/* This route has no `SMLContainer`: the upgrade prompt and the plan picker need their own mount. */}
      <FullScreenUpgradeHost />
    </div>
  );
};

export const DirectedVideoView = TypedMemo(DirectedVideoViewComponent);
